import React from "react";

import { Filter, ProjectsCards } from "./components";
import { useProjectsList } from "../../../contexts/ProjectsListContext";

const ProjectsSection = () => {
	const { filteredProjects, projectSectRef, filterData } = useProjectsList();

	return (
		<section className="projects-section" ref={projectSectRef}>
			<div className="projects-header">
				<div>
					<h1>
						{/* {activeFilter} */}
						{/* <sup>2</sup> */}
						Projects
					</h1>

					<span className="count-wrap transition-wrap">
						{/* <p className="count"> */}
						{
							filterData.filter(
								(filter) => filter.title === "all-projects"
							)[0]?.count
						}
						{
							filteredProjects?.filter(
								(project: any) => !project.needs_attention
							)?.length
						}
						{/* </p> */}
					</span>
				</div>

				<Filter />
			</div>

			{filteredProjects.length > 0 && <ProjectsCards />}
		</section>
	);
};

export default ProjectsSection;
